module.exports = __webpack_public_path__ + "img/bossbot-hd.d21ba27b.png";